import fetchData from "../utils/HttpClient";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";
import {CustomerManagerInterface} from "../interfaces/customer/CustomerManagerInterface";

export type ReviewHighlight = {
    value: string;
    label: string;
};

export type ReviewCharacteristic = {
    name: string;
    label: string;
    onPhoto: boolean;
};

export type ReviewSpec = ReviewCharacteristic & {
    value: string | null;
};

export type ReviewProduct = {
    id: number;
    code: string;
    articul: string;
    brand: string;
    name: string;
    humanUrl: string;
    catalogCode: string | null;
    image: string | null;
    url: string;
    price: {amount: number; currency: string} | null;
    hasStock: boolean;
    stockLabel: string | null;
};

export type ReviewItem = {
    position: number;
    suitability: string | null;
    summary: string | null;
    paragraphs: string[];
    pros: string[];
    cons: string[];
    isMain: boolean;
    specs: ReviewSpec[];
    product: ReviewProduct;
};

export type ReviewConclusionCard = {
    title: string;
    caption: string;
    value: string;
    isMain: boolean;
};

export type ProductReviewPayload = {
    slug: string;
    title: string;
    lead: string | null;
    intro: string[];
    highlights: ReviewHighlight[];
    characteristics: ReviewCharacteristic[];
    conclusion: {
        cards: ReviewConclusionCard[];
        note: string | null;
    };
    items: ReviewItem[];
};

export function getProductReview(
    slug: string,
    customer: CustomerInterface | CustomerManagerInterface | null = null
): Promise<ProductReviewPayload> {
    return fetchData("/api/review/" + slug, null, "GET", customer);
}
